import React from "react";
import Logo from "../logo/logo";
import Button from "../button/button";
import styles from "./StepLayout.module.scss";

interface StepAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  testId?: string;
}

interface StepLayoutProps {
  title?: React.ReactNode;
  children: React.ReactNode;
  primaryAction?: StepAction;
  secondaryAction?: StepAction;
  brand?: string;
  country?: string;
}

export const StepLayout: React.FC<StepLayoutProps> = ({
  title,
  children,
  primaryAction,
  secondaryAction,
  brand,
  country,
}) => {
  const hasActions = primaryAction || secondaryAction;
  const isSingle = (primaryAction && !secondaryAction) || (!primaryAction && secondaryAction);

  return (
    <div className={`stepper-flow-container o-page-wrap ${styles.container}`}>
      <div className={`${styles.logo} ariaNoBorder`}>
        <Logo brand={brand} country={country} />
      </div>
      {title && (
        <div className="step-layout-title" data-testid="step-layout-title">
          {title}
        </div>
      )}
      <div className={styles.content}>
        {children}
      </div>
      {hasActions && (
        <div className={`o-button-container ${styles.actions} ${isSingle ? styles.singleAction : ""}`}>
          {primaryAction ? (
            <div className={styles.actionButton}>
              <Button
                id="step-primary-button"
                testid={primaryAction.testId ?? "step-primary-button"}
                value={primaryAction.label}
                onClick={primaryAction.onClick}
                disabled={primaryAction.disabled ?? false}
                secondary
                customClass=""
                wrapperCustomClass=""
              />
            </div>
          ) : (
            <div />
          )}
          {secondaryAction ? (
            <div className={styles.actionButton}>
              <Button
                id="step-secondary-button"
                testid={secondaryAction.testId ?? "step-secondary-button"}
                value={secondaryAction.label}
                onClick={secondaryAction.onClick}
                disabled={secondaryAction.disabled ?? false}
                secondary={false}
                customClass=""
                wrapperCustomClass=""
              />
            </div>
          ) : (
            <div />
          )}
        </div>
      )}
    </div>
  );
};
